import { ChangeDetectorRef, Component, ViewChild, ElementRef, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { UtilsService } from 'src/app/services/utils.service';
import { environment } from '../../../environments/environment';
import { LoadingService } from '../../services/loading.service';
@Component({
    selector: 'app-aoi',
    templateUrl: './aoi.component.html',
    styleUrls: ['./aoi.component.css']
})

export class AoiComponent implements AfterViewInit {
    @ViewChild('stateTab') private readonly stateTab: ElementRef<any>;
    @ViewChild('regionTab') private readonly regionTab: ElementRef<any>;
    @ViewChild('routeTab') private readonly routeTab: ElementRef<any>;
    @ViewChild('assetIdTab') private readonly assetIdTab: ElementRef<any>;
    @ViewChild('addressTab') private readonly addressTab: ElementRef<any>;
    @ViewChild('latLongTab') private readonly latLongTab: ElementRef<any>;
    @ViewChild('intersectionTab') private readonly intersectionTab: ElementRef<any>;
    @ViewChild('mapPicker') private readonly mapPicker: ElementRef<any>;

    @Input() mapRef: any;

    @Output('done') done: EventEmitter<boolean> = new EventEmitter();

    @Input() loggedIn = true;
    @Output('shouldLogIn') shouldLogIn: EventEmitter<MouseEvent> = new EventEmitter();

    isLoading: boolean;

    hasExistingLayers: boolean;
    useExistingMap: boolean;

    aoiTabs = [
        { name: "State" },
        { name: "Region", active: true },
        { name: "Route" },
        { name: "Asset Id" },
        { name: "Address" },
        { name: "Lat/Long" }
    ];

    activeTab: any;
    aoiService: any;
    layerService: any;
    mapService: any;

    assetIdProperties = 'samples,bridges,permitNums,permitApps,mpmsprojects,tmsSite,billboardIds';

    constructor(private loadingService: LoadingService,
                private utilsService: UtilsService,
                private changeDetectorRef: ChangeDetectorRef) {
        window.addEventListener('openAoi', (e: CustomEvent) => {
            if (this.utilsService.mcMap.DeepLinkService.deepLinkParamIsPresent()) {
                this.generateMap(true);
            }
        });
    }

    ngAfterViewInit() {
        this.aoiService = this.stateTab.nativeElement.AoiService;
        this.layerService = this.mapRef.LayerService;
        this.mapService = this.mapRef.MapService;

        this.activeTab = this.regionTab;
        this.assetIdTab.nativeElement.config = environment.aoiSettings.assetIdConfig;
        this.assetIdTab.nativeElement.properties = this.assetIdProperties;

        this.mapPicker.nativeElement.config = environment.aoiSettings.mapPickerConfig;

        this.layerService.mapLayersSub.subscribe(layers => {
            if (layers) {
                this.hasExistingLayers = (Object.values(layers) as any).flat().length > 0 ? true : false;
                this.useExistingMap = this.hasExistingLayers;
            }
        });
    }

    activateTab() {
        this.activeTab.nativeElement.activate();
    }

    onTabChange(event) {
        switch (event.detail.name) {
            case 'State':
                this.aoiService.clearSearchCriterias();
                this.activeTab = this.stateTab;
                this.activateTab();
                break;

            case 'Region':
                this.aoiService.clearSearchCriterias();
                this.activeTab = this.regionTab;
                this.activateTab();
                break;

            case 'Route':
                this.aoiService.clearSearchCriterias();
                this.activeTab = this.routeTab;
                this.activateTab();
                break;

            case 'Asset Id':
                this.aoiService.clearSearchCriterias();
                this.activeTab = this.assetIdTab;
                this.activateTab();
                break;

            case 'Address':
                this.aoiService.clearSearchCriterias();
                this.activeTab = this.addressTab;
                this.activateTab();
                break;

            case 'Lat/Long':
                this.aoiService.clearSearchCriterias();
                this.activeTab = this.latLongTab;
                this.activateTab();
                break;
            case 'Intersection':
                this.aoiService.clearSearchCriterias();
                this.activeTab = this.intersectionTab;
                this.activateTab();
                break;

            default:
                break;
        }
    }

    existingMapChanged(event) {
        this.changeDetectorRef.detectChanges();
    }

    private async loadMap() {
        const map = this.getMapFromPicker();
        if (map) {
            await this.mapService.openMap(map, true);
        } else {
            await this.mapService.resetMap();
        }
    }

    public async generateMap(deepLinkProcessed: boolean = false) {
        const loadingIdentifyKey = 'generateMap';
        this.loadingService.add(loadingIdentifyKey);
        this.closeAoiTool();
        try {
            let visibleLayerIds = this.getVisibleLayerIdsFromMap();
            if (deepLinkProcessed || !this.useExistingMap) {
                await this.loadMap();
            }
            this.activeTab.nativeElement.addResultToMap();
            const result = await this.aoiService.showBySearchCriterias();
            if (visibleLayerIds.length > 0) {
                this.aoiService.turnOnLayerIds(visibleLayerIds);
            }
            if (deepLinkProcessed) {
                // Move the point of interest above the AOI layers
                const layer = this.layerService.mapView.map.layers.items[0];

                window.requestAnimationFrame(() => {
                    this.layerService.moveLayerToTheTop(layer);
                });
            }
            return result;
        } finally {
            this.loadingService.remove(loadingIdentifyKey);
        }
    }

    getMapFromPicker() {
        const map = this.mapPicker.nativeElement.map;
        if (map && map.data) {
            return map;
        }
        return null;
    }

    getMapData() {
        const map = this.getMapFromPicker();
        if (map && map.data) {
            return JSON.parse(map.data);
        }
        return null
    }

    getVisibleLayerIdsFromMap() {
        const mapData = this.getMapData();
        if (mapData) {
            if (mapData && mapData.layers) {
                return mapData.layers.filter(x => x.id && (x.visible || x.visible === undefined)).map(x => x.id);
            }
        }
        return [];
    }

    closeAoiTool() {
        this.done.emit(true);
    }

    login(e: MouseEvent) {
        this.shouldLogIn.emit(e);
    }
}
